module.exports = __webpack_public_path__ + "img/map-hours-table-cjdr.45bff4cc.png";